import { ReactNode } from "react";
import { useIsAdmin } from '@/hooks/auth';
import { Alert, AlertDescription } from "@/components/ui/alert";
import { ShieldX } from "lucide-react";

interface SuperAdminProtectedRouteProps {
  children: ReactNode;
}

// Guard para telas que operam sobre TODAS as organizações da plataforma.
// Diferente de ProtectedRoute (que aceita admin de qualquer org), aqui exigimos
// super admin — é o mesmo recorte da RLS de organizations (is_member OR is_super_admin),
// então um admin comum veria uma tela pela metade, com apenas a própria org.
export function SuperAdminProtectedRoute({ children }: SuperAdminProtectedRouteProps) {
  const { isSuperAdmin, loading } = useIsAdmin();

  // Show loading while checking permissions
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        <span className="ml-2 text-muted-foreground">Verificando permissões...</span>
      </div>
    );
  }

  // Only deny access after loading is complete and user is confirmed not super admin
  if (!loading && !isSuperAdmin) {
    return (
      <div className="container mx-auto px-6 py-8">
        <Alert variant="destructive">
          <ShieldX className="h-4 w-4" />
          <AlertDescription>
            Acesso negado. Apenas super administradores podem acessar esta página.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return <>{children}</>;
}
